// @flow

import { useAppSelector } from 'src/hooks/useAppSelector';
import type { ServicePrice } from 'src/types/price';

import { resource } from '../modules/actions';
import { selectPrices } from '../modules/selector';

/**
 * Retrieve tmch prices and resource state.
 * No fetch is made here, cf. `Tmch/index`
 */
export function useTmchPrices(): {
  prices: Array<ServicePrice>,
  pricesFailure: boolean,
  pricesFetching: boolean,
  pricesLoaded: boolean,
} {
  const prices = useAppSelector(selectPrices);

  const pricesLoaded = useAppSelector(resource.selectIsLoaded);
  const pricesFailure = useAppSelector(resource.selectIsFailure);
  const pricesFetching = useAppSelector(resource.selectIsFetching);

  return {
    prices,
    pricesLoaded,
    pricesFailure,
    pricesFetching,
  };
}
